jQuery(function () {

	// copy debug info textarea
	jQuery("#debug-info-button").on("click", function () {
		wpm.copyTextToClipboard(jQuery("#debug-info-textarea").val());
	});

	jQuery("#pmw-pro-version-demo").on("click", function () {
		jQuery("#submit").trigger("click");
	});

	if (document.getElementById("json-settings-file-input")) {
		document.getElementById("json-settings-file-input")
			.addEventListener("change", wpm.readSettingsFile, false);
	}

	// if element ga4-data-api-credentials-upload-button exists, then we are on the GA4 settings page
	if (document.getElementById("ga4-data-api-credentials-upload-button")) {

		document.getElementById("ga4-data-api-credentials-upload-button")
			.addEventListener("change", wpm.readGa4DataApiCredentials, false);

		document.getElementById("ga4-data-api-credentials-delete-button")
			.addEventListener("click", () => {
				wpm.saveGa4DataApiCredentialsToDb({});
			}, false);
	}

});

// jQuery(function () {
//
// 	import("../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs")
// 		.then(({
// 				   computePosition,
// 				   flip,
// 				   shift,
// 				   offset,
// 			arrow,
// 			   }) => {
// 			console.log("computePosition: ", computePosition)
//
// 			const button = document.querySelector('#button');
// 			const tooltip = document.querySelector('#tooltip');
// 			const arrowElement = document.querySelector('#arrow');
//
// 			computePosition(button, tooltip, {
// 				placement: 'top',
// 				middleware: [
// 					offset(6),
// 					flip(),
// 					shift({padding: 5}),
// 					arrow({element: arrowElement}),
// 				],
// 			}).then(({x, y}) => {
// 				Object.assign(tooltip.style, {
// 					left: `${x}px`,
// 					top: `${y}px`,
// 				});
// 			});
//
// 		})
// 		.catch(err => {
// 			console.error(err)
// 		})
//
// });


(function (wpm, $, undefined) {

	wpm.saveSettingsToDisk = (version) => {
		let text             = document.getElementById("export-settings-json").value;
		text                 = text.replace(/\n/g, "\r\n"); // To retain the Line breaks.
		let blob             = new Blob([text], {type: "text/plain"});
		let anchor           = document.createElement("a");
		anchor.download      = "pixel-manager-settings_" + version + "_" + wpm.getCurrentDateForFileName() + ".json";
		anchor.href          = window.URL.createObjectURL(blob);
		anchor.target        = "_blank";
		anchor.style.display = "none"; // just to be safe!
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	};

	// Get date in year month day divided by dots. Month and day have to be zero padded.
	wpm.getCurrentDateForFileName = () => {
		let date  = new Date();
		let year  = date.getFullYear();
		let month = ("0" + (date.getMonth() + 1)).slice(-2);
		let day   = ("0" + date.getDate()).slice(-2);
		return year + "." + month + "." + day;

		// return date.toLocaleDateString(
		// 	"en-US", {
		// 		year : "numeric",
		// 		month: "2-digit",
		// 		day  : "2-digit",
		// 	},
		// )
	};

	wpm.readSettingsFile = e => {

		let file = e.target.files[0];
		if (!file) return;
		let reader    = new FileReader();
		reader.onload = function (e) {

			// Check if the file is a valid JSON file
			// If it is not a valid JSON file, display an error message
			try {
				JSON.parse(e.target.result);
			} catch (error) {
				document.getElementById("settings-upload-status-error").style.display     = "block";
				document.getElementById("settings-upload-status-error-message").innerHTML = "Invalid JSON file.";
				return;
			}

			let contents = JSON.parse(e.target.result);

			// document.getElementById("import-settings-json").textContent = JSON.stringify(contents)

			wpm.saveImportedSettingsToDb(contents);
		};
		reader.readAsText(file);
	};

	wpm.saveImportedSettingsToDb = settings => {

		fetch(pmwAdminApi.root + "pmw/v1/settings/", {
			method     : "POST",
			credentials: "same-origin",
			headers    : {
				"Content-Type": "application/json",
				"X-WP-Nonce"  : pmwAdminApi.nonce,
			},
			body       : JSON.stringify(settings),
		})
			.then(response => response.json())
			.then(async message => {
				if (message.success) {
					console.log(message);
					// reload window
					document.getElementById("settings-upload-status-success").style.display = "block";
					// wait 5 seconds
					await new Promise(resolve => setTimeout(resolve, 1000));
					window.location.reload();
				} else {
					console.log(message);
					document.getElementById("settings-upload-status-error").style.display = "block";
				}
			})
			.catch(error => {
				console.error(error);
				document.getElementById("settings-upload-status-error").style.display = "block";
			});
	};

	wpm.readGa4DataApiCredentials = e => {

		let file = e.target.files[0];
		if (!file) return;
		let reader    = new FileReader();
		reader.onload = function (e) {

			// Check if the file is a valid JSON file
			// If it is not a valid JSON file, display an error message
			try {
				JSON.parse(e.target.result);
			} catch (error) {
				document.getElementById("ga4-api-credentials-upload-status-error").style.display     = "block";
				document.getElementById("ga4-api-credentials-upload-status-error-message").innerHTML = "Invalid JSON file.";
				return;
			}

			let contents = JSON.parse(e.target.result);

			// document.getElementById("import-settings-json").textContent = JSON.stringify(contents)

			wpm.saveGa4DataApiCredentialsToDb(contents);
		};
		reader.readAsText(file);
	};

	wpm.deleteGa4DataApiCredentials = e => {
		wpm.saveGa4DataApiCredentialsToDb({});
	};

	wpm.saveGa4DataApiCredentialsToDb = credentials => {

		fetch(pmwAdminApi.root + "pmw/v1/ga4/data-api/credentials", {
			method     : "POST",
			credentials: "same-origin",
			headers    : {
				"Content-Type": "application/json",
				"X-WP-Nonce"  : pmwAdminApi.nonce,
			},
			body       : JSON.stringify(credentials),
		})
			.then(response => response.json())
			.then(async responseJson => {
				if (responseJson.success) {
					console.log(responseJson);
					// reload window
					document.getElementById("ga4-api-credentials-upload-status-success").style.display = "block";
					// wait 5 seconds
					// await new Promise(resolve => setTimeout(resolve, 5000))
					window.location.reload();
				} else {
					console.log(responseJson);
					document.getElementById("ga4-api-credentials-upload-status-error").style.display     = "block";
					// and add the error message
					document.getElementById("ga4-api-credentials-upload-status-error-message").innerHTML = "Error message: " + responseJson.data.message;
				}
			})
			.catch(error => {
				console.error(error);
				document.getElementById("ga4-api-credentials-upload-status-error").style.display = "block";
			});
	};

	wpm.getAiBotUrl = () => {
		if(pmw_cody?.url) {
			return pmw_cody.url;
		}
	};

	/**
	 * openChatModal must open a modal window with the chat window in it
	 * It is an overlay over the current page, half transparent
	 * 80% of the overlay is used by the actual chat window
	 * The chat window is a chatbot that's loaded from https://widget.getcody.ai/public/9a20c1c8-4323-4656-a4f8-02face5dc0e7
	 */
	wpm.loadAiChatWindow = () => {

		// console.log("openChatModal()")

		// add a half transparent overlay over the current page
		// the overlay is 100% width and 100% height
		// the overlay is fixed to the top left corner of the page
		// the overlay has a z-index of 1000
		// the overlay has a background color of rgba(0,0,0,0.5)

		// console.log("openChatModal() - add overlay")

		let overlay                   = document.createElement("div");
		overlay.id                    = "pmw-chat-overlay";
		overlay.style.position        = "fixed";
		overlay.style.top             = "0";
		overlay.style.left            = "0";
		overlay.style.width           = "100%";
		overlay.style.height          = "100%";
		overlay.style.zIndex          = "1000";
		overlay.style.backgroundColor = "rgba(0,0,0,0.5)";
		overlay.style.display         = "flex";
		overlay.style.justifyContent  = "center";
		overlay.style.alignItems      = "center";

		// now show the overlay within the element with ID "wpbody"

		// console.log("openChatModal() - show overlay")

		let wpbody = document.getElementById("wpbody");
		wpbody.appendChild(overlay);

		// within that overly add a div that is 80% of the width and 80% of the height
		// it has white background and a z-index of 1001

		// console.log("openChatModal() - add chat window container")

		var chatWindowContainer                  = document.createElement("div");
		chatWindowContainer.id                   = "pmw-chat-window-container";
		chatWindowContainer.style.width          = "80%";
		chatWindowContainer.style.height         = "80%";
		// chatWindowContainer.style.backgroundColor = 'white';
		chatWindowContainer.style.zIndex         = "1001";
		chatWindowContainer.style.display        = "flex";
		chatWindowContainer.style.justifyContent = "center";
		chatWindowContainer.style.alignItems     = "center";
		// left margin 160px
		chatWindowContainer.style.marginLeft     = "160px";

		// now show the chat window container
		overlay.appendChild(chatWindowContainer);

		// within that chat window container add an iframe that loads the chat window

		// console.log("openChatModal() - add chat window iframe")

		var chatWindowIframe = document.createElement("iframe");

		chatWindowIframe.src          = wpm.getAiBotUrl();
		chatWindowIframe.style.width  = "100%";
		chatWindowIframe.style.height = "100%";
		chatWindowIframe.style.border = "none";

		// now show the chat window iframe
		chatWindowContainer.appendChild(chatWindowIframe);

		// when clicking outside of the chat window container, close the chat window
		overlay.addEventListener("click", function (event) {
			// console.log("overlay.addEventListener()")
			console.log(event.target);
			if (event.target.id === "pmw-chat-overlay") {
				console.log("overlay.addEventListener() - close chat window");
				overlay.remove();
			}
		});

		// also close the chat window when pressing the ESC key
		document.addEventListener("keydown", function (event) {
			if (event.key === "Escape") {
				// console.log("document.addEventListener() - close chat window")
				overlay.remove();
			}
		}, true);
	};

	wpm.codyAvailable = () => {
		if (pmw_cody?.available) {
			return true;
		}

		return false;
	};

	// Schedule a recalculation of the LTV by sending a POST REST request to the server
	wpm.ltvRecalculation = event => {

		const displayStatusMessage = (message) => {
			let elements = document.getElementsByClassName("ltv-message");
			for (let i = 0; i < elements.length; i++) {
				elements[i].style.display = "none";
			}
			document.getElementById("ltv-message-error").style.display  = "block";
			document.getElementById("ltv-message-error-text").innerHTML = message;
		};

		const displayRunImmediatelyButton = () => {
			let elements = document.getElementsByClassName("ltv-button-text");
			for (let i = 0; i < elements.length; i++) {
				elements[i].style.display = "none";
			}
			document.getElementById("ltv-instant-recalculation-button-text").style.display = "block";
		};

		const removeAllMessages = () => {
			let elements = document.getElementsByClassName("ltv-message");
			for (let i = 0; i < elements.length; i++) {
				elements[i].style.display = "none";
			}

			document.getElementById("ltv-message-error").style.display = "none";
		};

		// console log the data-action from the nested span element of the clicked element
		// console.log("event.target.dataset.action", event.target.dataset.action)

		fetch(pmwAdminApi.root + "pmw/v1/ltv/", {
			method     : "POST",
			credentials: "same-origin",
			headers    : {
				"Content-Type": "application/json",
				"X-WP-Nonce"  : pmwAdminApi.nonce,
			},
			body       : JSON.stringify({
				"action": event.target.dataset.action,
			}),
		})
			.then(response => response.json())
			.then(message => {
				if (message.success) {
					console.log(message);
					// reload window

					if (message.data.status.is_scheduled) {
						removeAllMessages();
						displayRunImmediatelyButton();
						document.getElementById("ltv-schedule-recalculation-confirmation-message").style.display = "block";
					}

					if (message.data.status.is_running) {
						// Get the button element with the id "wgact_ltv_recalculation" and disable it
						document.getElementById("wgact_ltv_recalculation").disabled = true;
						removeAllMessages();
						document.getElementById("ltv-running-recalculation-confirmation-message").style.display = "block";
					}

					// if is neither message.data.status.is_running nor message.data.status.is_scheduled
					// then display the error message
					if (!message.data.status.is_running && !message.data.status.is_scheduled) {
						displayStatusMessage(message.data.message);
					}
				} else {
					console.error(message);
					displayStatusMessage(message.data.message);
				}
			})
			.catch(error => {
				console.error(error);
				displayStatusMessage(error);
			});
	};

	wpm.copyTextToClipboard = async (text) => {
		try {
			await navigator.clipboard.writeText(text);
			// console.log('Text copied to clipboard');
		} catch (err) {
			console.error("Failed to copy: ", err);
		}
	};

}(window.wpm = window.wpm || {}, jQuery));

/**
 * This script is used to track the mouse position and set the transparency
 * of the button with which the pro-demo can be enabled.
 */
document.addEventListener("DOMContentLoaded", () => {

	// Get the pmw_pro_version_demo element and save it in a variable
	const elementToTrack = document.getElementById("pmw-pro-version-demo");

	// Only continue if the element exists
	if (!elementToTrack) {
		return;
	}

	// This is a span element that contains two input elements.
	// Only continue if both are not checked.
	if (elementToTrack.querySelector("input:checked")) {
		return;
	}

	const maxWidth = window.innerWidth / 2;

	const calculateTheDistanceInPercent = (mousePosition, maxWidth) => {

		// Get the element position and save it in a variable
		const elementPosition = elementToTrack.getBoundingClientRect();
		const distance        = Math.sqrt(Math.pow(mousePosition.clientX - elementPosition.left, 2) + Math.pow(mousePosition.clientY - elementPosition.top, 2));

		return distance / maxWidth;  // returns the percentage
	};

	const setTransparency = (percentage) => {

		if (percentage > 1) {
			percentage = 1;
		}

		const maximumReduction = 80;
		const reduction        = maximumReduction * percentage;
		const transparency     = 100 - reduction;

		elementToTrack.classList.add("pmw-opacity-transition");
		elementToTrack.style.opacity = transparency / 100;
	};

	document.addEventListener("mousemove", event => {
		const distanceInPercent = calculateTheDistanceInPercent(event, maxWidth);
		setTransparency(distanceInPercent);
	});
}, true);

/**
 * The function waits for the DOMContentLoaded event,
 * and then it makes a call to get the server status of an aiBot (provided by its URL).
 * If the server status code is 200, it changes the display style of an HTML element with the id "pmw-chat-li" to "block",
 * making it visible in the webpage. If the server status request fails, it logs the message
 * "DOMContentLoaded - chatbot is not available" to the console.
 *
 * @listens document#DOMContentLoaded
 */
document.addEventListener("DOMContentLoaded", () => {

	if (wpmDataLayer.version.distro !== "fms") return;

	if (wpm.codyAvailable()) {
		document.getElementById("pmw-chat-li").style.display = "block";
	} else {
		console.log("DOMContentLoaded - chatbot is not available");
	}

}, true);

// Wait until the DOM is loaded, then console log
// the message "DOMContentLoaded - chatbot is not available"
// use jquery
jQuery(() => {
	if (document.querySelector("#wgact_ltv_recalculation")) {
		document.querySelector("#wgact_ltv_recalculation").addEventListener("click", event => {
			event.preventDefault();
			wpm.ltvRecalculation(event);
		});
	}

	if (document.querySelector("#pmw_stop_ltv_calculation")) {
		document.querySelector("#pmw_stop_ltv_calculation").addEventListener("click", event => {
			event.preventDefault();
			wpm.ltvRecalculation(event);
		});
	}
});

/**
 * add an event listener to the button with the id "wgact_copy_log_file_links"
 * when the button is clicked, copy the log file links to the clipboard
 * the data-links attribute of the button contains a json string with the links
 */
jQuery(() => {

	if (!document.querySelector("#wgact_copy_log_file_links")) {
		return;
	}

	document.querySelector("#wgact_copy_log_file_links").addEventListener("click", event => {
		event.preventDefault();

		const jsonOfLinks = JSON.parse(event.target.dataset.links);

		let strOfLinks = "";

		for (let i = 0, len = jsonOfLinks.length; i < len; i++) {
			strOfLinks += jsonOfLinks[i] + "\n";
		}

		wpm.copyTextToClipboard(strOfLinks);

		// make the button text change to "Copied!" and keep the same width and text for 3 seconds
		let button         = document.getElementById("wgact_copy_log_file_links");
		button.style.width = getComputedStyle(button).width;
		const originalText = button.innerHTML;
		button.innerHTML   = event.target.dataset.textCopied;
		setTimeout(function () {
			button.innerHTML = originalText;
		}, 3000);
	});
});

// on pressing enter, click the submit button
jQuery(() => {
	jQuery(document).on("keydown", function (event) {
		if (event.key === "Enter") {
			jQuery("#submit").click();
		}
	});
});
